// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","rotation":"Spinner_rotation__1xbqJ"};